"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.component = exports.ExpandCollapseComponent = void 0;
const app_1 = require("app");
const app_2 = require("app");
const backgroundImg = 'background-image';
class ExpandCollapseComponent extends app_1.Component {
    constructor() {
        super(...arguments);
        this.selector = '.expand-collapse-elem';
    }
    BeforeInit() {
        this.el.forEach(element => {
            const externalLink = new app_1.ExternalLink(element.querySelectorAll('a'));
            externalLink.checkLinks('text-[20px] mt-0.5 self-center');
            const expandItemList = element.querySelectorAll('.expand-collapse-item');
            expandItemList.forEach((item) => {
                this.initItem(item);
            });
        });
    }
    initItem(item) {
        const playButton = item.querySelector('.play-video-button');
        const imgEmpty = item.querySelector('.img-empty');
        if (playButton) {
            this.putImageFromVideo(playButton, imgEmpty);
        }
    }
    putImageFromVideo(playButton, imgEmpty) {
        const isValidUrl = app_2.VideoService.checkIsValidVideo(playButton.getAttribute('data-url'));
        let newSrc;
        if (!isValidUrl)
            playButton.classList.add('hidden');
        newSrc = playButton.getAttribute('data-url');
        newSrc = newSrc ? app_2.VideoService.getPreviewImage(newSrc) : null;
        if (!imgEmpty)
            return;
        imgEmpty.style.minHeight = '360px';
        imgEmpty.style.backgroundSize = 'cover';
        imgEmpty.style.backgroundImage = newSrc
            ? `url('${newSrc}')`
            : `url('${app_1.PathEnum.DefaultVideoImage}')`;
    }
}
exports.ExpandCollapseComponent = ExpandCollapseComponent;
exports.component = new ExpandCollapseComponent();
